import logoDark from '../assets/logo-dark.png';
import logoLight from '../assets/logo-light.png';
import { useTheme } from '../contexts/ThemeContext';

/**
 * Full wordmark for auth pages: dark logo on light UI, light logo on dark UI.
 */
const AuthBrandLogo = ({ className = 'h-9 w-auto max-w-[200px] object-contain object-left' }) => {
  const { theme } = useTheme();
  const src = theme === 'dark' ? logoDark : logoLight;

  return <img src={src} alt="DocTree" className={className} />;
};

export default AuthBrandLogo;
